import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import RequestChurnButton from './RequestChurnButton';
import RequestChurnCancelButton from './RequestChurnCancelButton';

const RequestChurnButtonPicker = ({
  collection,
}) => {
  const [outerResource] = collection;

  return pickFunction(outerResource, {
    [fr.relationships.requestChurn.name]: () => {
      return (<RequestChurnButton resource={outerResource} />);
    },
    [fr.relationships.requestChurnCancel.name]: () => {
      return <RequestChurnCancelButton resource={outerResource} />;
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

RequestChurnButtonPicker.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default RequestChurnButtonPicker;
